export default __webpack_public_path__ + "static/media/SWT1370.34I-35001_-24506_0.ab838707.jpg";